
import React from "react";
import type { MortgageData } from "../../CalculatorTabs";
import { calculateFundingFee } from "../../utils/fundingFeeCalculations";
import { formatCurrency } from "../../utils/formatters";

interface VAFundingFeeInfoProps {
  mortgageData: MortgageData;
}

const VAFundingFeeInfo: React.FC<VAFundingFeeInfoProps> = ({ mortgageData }) => {
  // Calculate the funding fee
  const fundingFeeInfo = calculateFundingFee(
    "va",
    mortgageData.homePrice - mortgageData.downPayment,
    mortgageData.homePrice,
    mortgageData.downPayment,
    mortgageData.downPaymentPercentage,
    mortgageData.isFirstTimeHomebuyer,
    mortgageData.vaStatus,
    mortgageData.homebuyingHistory,
    mortgageData.vaDisabilityStatus
  );

  return (
    <div className="bg-muted rounded-md p-3 text-sm">
      {mortgageData.vaDisabilityStatus === "full" && (
        <p className="font-medium text-green-600">
          100% Disability: $0 down payment, $0 funding fee, no PMI, exempt from property taxes
        </p>
      )}
      {mortgageData.vaDisabilityStatus === "partial" && (
        <p className="font-medium text-green-600">
          10%-90% Disability: $0 down payment, $0 funding fee, no PMI
        </p>
      )}
      {mortgageData.vaDisabilityStatus === "none" && (
        <>
          <p className="font-medium">VA Funding Fee:</p>
          <p>
            {fundingFeeInfo.percentage}% ({formatCurrency(fundingFeeInfo.amount)})
            {mortgageData.rollFundingFeeIntoLoan && 
              <span className="text-emerald-600 ml-1">(Added to Loan)</span>
            }
          </p>
          {mortgageData.vaStatus === "activeDuty" &&
           (mortgageData.homebuyingHistory === "firstTime" ||
            mortgageData.homebuyingHistory === "purchasedLastThreeYears") && (
            <p className="mt-1 text-green-600">
              Eligible for $0 down payment and no PMI
            </p>
          )}
        </>
      )}
    </div>
  );
};

export default VAFundingFeeInfo;
